import type { MRT_ColumnDef } from "mantine-react-table-open";
import type {
  EnergyRevenuesListItem,
  GetEnergyRevenuesTableColumnParams
} from "../../../RevenueMonitoring.types";
import { getMarketPremiumRevenueColumn } from "../columns/getMarketPremiumRevenueColumn";
import { getMarketPremiumVolumeColumn } from "../columns/getMarketPremiumVolumeColumn";
import { getNegativePriceRevenueColumn } from "../columns/getNegativePriceRevenueColumn";
import { getNegativePriceVolumeColumn } from "../columns/getNegativePriceVolumeColumn";

export function getMarketPremiumColumnGroup({
  companyId,
  dataVerificationColumns,
  dataVerificationItems,
  columnVisibility
}: GetEnergyRevenuesTableColumnParams): MRT_ColumnDef<EnergyRevenuesListItem> {
  return {
    id: "market_premium",
    header:
      "Förderung tatsächliche Einspeisung inkl. Einblick §51 EEG Mengen (Abrechnung Netzbetreiber)",
    mantineTableHeadCellProps: {
      className: "column-group-header-border-left"
    },
    columns: [
      getMarketPremiumVolumeColumn({
        companyId,
        dataVerificationColumns,
        dataVerificationItems,
        columnVisibility
      }),
      getMarketPremiumRevenueColumn({
        companyId,
        dataVerificationColumns,
        dataVerificationItems,
        columnVisibility
      }),
      getNegativePriceVolumeColumn({
        companyId,
        dataVerificationColumns,
        dataVerificationItems,
        columnVisibility
      }),
      getNegativePriceRevenueColumn({
        companyId,
        dataVerificationColumns,
        dataVerificationItems,
        columnVisibility
      })
    ]
  };
}
